// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"e270467b","234":"f8eb1159","320":"0ad048fc","390":"cfb0e34a","549":"a20080b6","557":"f0bc3b03","642":"3352b04d","702":"27963ee3","859":"ed641b81","915":"6294bcda","921":"8e34e379","956":"4c672136","962":"41d3f8a1"}[chunkId] + ".chunk.js";
};